// Hộp "Sao lưu plugin" mở từ dòng sao lưu trên thẻ bot (07/10/2026): các bản sao lưu dữ liệu plugin Boss đang giữ cho bot này (giờ, cỡ, phiên bản,
// số dòng sổ cái / lần chạy…) + "Chép bản sao lưu từ bot khác" (máy mới / ghép cặp lại thành bot mới: chép bản mới nhất của bot cũ CÙNG chủ sang,
// rồi trên máy bot bấm "Khôi phục từ Boss…" ở Cài đặt → Kết nối Boss). Khôi phục chỉ làm được TẠI MÁY BOT (Boss không ghi đè dữ liệu máy từ xa).
// API: server/src/plugin-sao-luu.ts. Chữ từ máy chủ luôn qua textContent (h()).
import { api, errMsg } from "../api";
import { busy, confirmBox, h, toast } from "../dom";
import type { Bot } from "../types";
import { moHop } from "./bot-hop";
import { chuKichCo, type MetaSaoLuu } from "../../../../src/shared/sao-luu-plugin";
import { gioVn } from "../../../../src/shared/canh-bao-plugin";

interface NguonSl { botId: string; ten: string; thuHoi: boolean; soBan: number; luc: string; kichCo: number }

const gio = (iso: string): string => gioVn(iso) ?? "?";
const chuDem = (d: MetaSaoLuu["dem"]): string => `${d.soCai} dòng sổ cái · ${d.lanChay} lần chạy · ${d.banDaHoc} bản đã học · ${d.kichBan} kịch bản`;

export function hopSaoLuu(b: Bot, khiDoi: () => void): void {
  const hop = moHop(`Sao lưu plugin — ${b.name}`, "bot-sao-luu-hop", "sao-luu-hop");
  if (!hop) return;
  const ds = h("div", { class: "sl-ds", "data-testid": "sl-ds" }, h("p", { class: "muted small" }, "Đang tải…"));
  const chep = h("div", { class: "sl-chep", "data-testid": "sl-chep" });
  hop.than.append(
    h("p", { class: "small muted wrap" }, "Plugin trên máy bot tự gửi bản sao dữ liệu (sổ cái chống đăng trùng, lịch sử chạy, bản đã học, kịch bản, cài đặt — không có mật khẩu / khoá API) lên Boss mỗi ngày và trước khi tự cập nhật. Boss giữ 5 bản mới nhất. Khôi phục: trên máy bot mở Cài đặt → Kết nối Boss → Khôi phục từ Boss…"),
    ds, chep);
  hop.chan.append(h("button", { type: "button", title: "Đóng hộp này", "data-testid": "bot-hop-dong", onclick: hop.dong }, "Đóng"));

  const taiDs = async (): Promise<void> => {
    ds.replaceChildren(h("p", { class: "muted small" }, "Đang tải…"));
    try {
      const r = await api<{ ds: MetaSaoLuu[] }>("GET", `/api/bots/${encodeURIComponent(b.id)}/sao-luu`);
      ds.replaceChildren();
      if (!r.ds.length) { ds.append(h("p", { class: "muted small", "data-testid": "sl-trong" }, "Chưa có bản sao lưu nào. Bot bản plugin cũ chưa biết sao lưu — bot tự lên bản mới rồi sẽ gửi.")); return; }
      for (const m of r.ds) {
        ds.append(h("div", { class: "sl-ban", "data-testid": "sl-ban", dataset: { id: m.id } },
          h("div", { class: "sl-ban-dau" }, h("b", {}, gio(m.taoLuc)), ` · ${chuKichCo(m.kichCo)} · plugin ${m.extVersion || "?"}`, m.tuBot ? h("span", { class: "tag", title: "Bản này được chép từ bot khác" }, `chép từ ${m.tuBot.ten}`) : null),
          h("div", { class: "small muted wrap" }, chuDem(m.dem))));
      }
    } catch (e) {
      ds.replaceChildren(h("div", { class: "err-box", role: "alert", "data-testid": "sl-loi" }, h("span", {}, errMsg(e)), h("button", { type: "button", title: "Hỏi lại máy chủ danh sách bản sao lưu", onclick: () => void taiDs() }, "Thử lại")));
    }
  };

  const taiNguon = async (): Promise<void> => {
    chep.replaceChildren();
    let nguon: NguonSl[];
    try { nguon = (await api<{ ds: NguonSl[] }>("GET", `/api/bots/${encodeURIComponent(b.id)}/sao-luu/nguon`)).ds; } catch { return; } // phần phụ: lỗi thì không hiện
    if (!nguon.length) return;
    const chon = h("select", { "data-testid": "sl-nguon", title: "Bot cũ (cùng tài khoản) có bản sao lưu — bản MỚI NHẤT của bot đó sẽ được chép sang bot này" },
      ...nguon.map((n) => h("option", { value: n.botId }, `${n.ten}${n.thuHoi ? " (đã thu hồi)" : ""} — ${gio(n.luc)} · ${chuKichCo(n.kichCo)}`)));
    const nut = h("button", { type: "button", class: "pri", "data-testid": "sl-chep-nut", title: "Chép bản sao lưu mới nhất của bot đã chọn sang bot này (không đụng dữ liệu trên máy bot nào)" }, "Chép sang bot này");
    nut.addEventListener("click", () => void busy(nut, "Đang chép…", async () => {
      const n = nguon.find((x) => x.botId === chon.value);
      if (!n) return;
      if (!(await confirmBox({ title: "Chép bản sao lưu?", text: `Chép bản sao lưu mới nhất của “${n.ten}” (${gio(n.luc)}) sang “${b.name}”. Sau đó trên máy bot “${b.name}” bấm Khôi phục từ Boss… để gộp vào máy.`, okText: "Chép" }))) return;
      try {
        await api("POST", `/api/bots/${encodeURIComponent(b.id)}/sao-luu/chep-tu`, { tuBotId: n.botId });
        toast(`Đã chép bản sao lưu của ${n.ten} sang ${b.name}`);
        khiDoi();
        await taiDs();
      } catch (e) { toast(errMsg(e), "err"); }
    }));
    chep.append(h("h4", {}, "Máy mới / ghép cặp lại?"), h("p", { class: "small muted wrap" }, "Chép bản sao lưu của bot cũ cùng tài khoản sang bot này:"), h("div", { class: "row sl-chep-hang" }, chon, nut));
  };

  void taiDs();
  void taiNguon();
}
